declare const _APP_VERSION: string;

export class ConfigConstants {
    static APP_VERSION = _APP_VERSION;
}
